import React, { useContext } from 'react';
import { Container, Hidden } from '@material-ui/core';
import ModalItem from '../../common/ModalItem/ModalItem';
import IsMobileContext from '../../../common/IsMobileContext';
import { Link, Route, Switch } from 'react-router-dom';
import { completedRoutes } from '../../../common/constants';


const ContentSwitch = (props) => {
  const { desktopOption, content } = props;

  return (
    <Switch>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

const UndefinedPlace = () => {
  const isMobileDesign = useContext(IsMobileContext);

  const content = (
    <Container>
      <div>
        <h2>Компания удалена с проекта или никогда не существовала.</h2>
        <p>Посмотрите <Link to={completedRoutes.userTasks}>задания от других.</Link></p>
      </div>
    </Container>
  );

  return (
    <ModalItem>
      <>
        <Hidden mdUp>
          {content}
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} />
      </>
    </ModalItem>
  );
}

export default UndefinedPlace;
